module.exports = __webpack_public_path__ + "img/ground_1.b4c96482.png";